import { render, staticRenderFns } from "./keywordSale.vue?vue&type=template&id=d4d924f8"
import script from "./keywordSale.vue?vue&type=script&lang=js"
export * from "./keywordSale.vue?vue&type=script&lang=js"
import style0 from "./keywordSale.vue?vue&type=style&index=0&id=d4d924f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports